// AI Generated Test
import { Component, OnInit } from '@angular/core';
import { PageRepoService } from '@client/app/services/api/page-repo/page-repo.service';
import { PagesTabsHelper } from '@client/app/blocks/helpers/pages-tabs.helper';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { REGULATIONS } from '../../constants/regulations.constant';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { BaseContainerComponentController } from '@client/app/blocks/base/base.controller';

@Component({
    selector: 'privacy-list',
    standalone: false,
    template: `
        <div class="data-privacy" id="data-privacy-list">
            <page-header
                [icon]="['SIDEMENUES', 'DATA_PRIVACY', 'LIST'] | monIcons"
                [header]="'Issues by Page' | translate"
                [subHeader]="subheaderTranslation">
            </page-header>
            <mon-tabs
                    [options]="tabs"
                    [(status)]="activeTab"
                    (onStatus)="onStatus($event)"
                    (onSearch)="onSearch($event)"
                    [search]="search"
                    [minSearchLength]="1"
                    [showFiltersBtn]="showFilters"
                    [(isFiltersOpen)]="isFiltersOpen"
                    [showSearch]="true">
                <csv-export-button [exports]="exports"></csv-export-button>
            </mon-tabs>
            <div class="card panel-monsido-card">
                <div class="card-body">
                    <table-container [noResultMessage]="getEmptyText()"
                                     [collection]="pages"
                                     (onPageChange)="onPageChange($event)"
                                     (onPerPageChange)="onPageSizeChange($event)"
                                     [progress]="promise"
                                     class="pages-table-wrapper"
                    >
                        <table-container-top>
                            <div class="outer-b merge-r-36 merge-l-36 merge-t-10" *ngIf="isFiltersOpen">
                                <table-filters [(open)]="isFiltersOpen"
                                               [(ngModel)]="filters"
                                               name="filters"
                                               [filters]="availableFilters"
                                               (onChanges)="onFiltersChanges($event)">
                                </table-filters>
                            </div>
                        </table-container-top>
                        <table class="table table-hover table-fixed table-with-labels">
                            <thead>
                            <tr>
                                <th monTableSort
                                    [monSortBy]="'title'"
                                    [monSortDirection]="currentSort.direction"
                                    [monCurrentlySortedBy]="currentSort.by"
                                    (monOnSorted)="onMonTableSort($event)"
                                    [monThTitle]="'Title and URL' | translate">
                                </th>
                                <th monTableSort
                                    class="text-right col-8 col-lg-8"
                                    [monSortBy]="'notification_count'"
                                    [monThTitle]="'Notifications' | translate"
                                    [monSortDirection]="currentSort.direction"
                                    [monCurrentlySortedBy]="currentSort.by"
                                    (monOnSorted)="onMonTableSort($event)">
                                </th>
                                <th *ngIf="!(activeTab === 'pdf' || activeTab === 'document') && viewsColumIsAvailable"
                                    class="table-header-page-views text-right col-7 col-lg-5"
                                    monTableSort
                                    [monSortBy]="'hits'"
                                    [monThTitle]="'Views' | translate"
                                    [monSortDirection]="currentSort.direction"
                                    [monCurrentlySortedBy]="currentSort.by"
                                    (monOnSorted)="onMonTableSort($event)">
                                    <span class="outer-l-smurf fas fa-question-circle"
                                          aria-hidden="true"
                                          [ngbTooltip]="'Total page views over the last 30 days' | translate"
                                          [triggers]="'focus hover'">
                                    </span>
                                </th>
                                <th class="col-7">&nbsp;</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let page of pages">
                                <td>
                                    <div class="text-ellipsis">
                                        <mon-url-title
                                                *ngIf="!pageDetailsIsAvailable"
                                                [title]="page.title"
                                                [url]="page.url"
                                                [active]="false">
                                        </mon-url-title>
                                        <url-title-page-details
                                                *ngIf="pageDetailsIsAvailable && page.type === 'html'"
                                                [target]="target"
                                                [subTarget]="subTarget"
                                                [page]="page"
                                                [title]="pageTitle(page.title)"
                                                [url]="page.url"
                                                [active]="true">
                                        </url-title-page-details>
                                        <url-title-document-details *ngIf="pageDetailsIsAvailable && page.type !== 'html'"
                                                                    [document]="page"
                                                                    [title]="pageTitle(page.title)"
                                                                    [url]="page.url"
                                                                    [active]="true"
                                                                    [target]="target"
                                                                    [subTarget]="subTarget">
                                        </url-title-document-details>
                                    </div>
                                    <label-table *ngIf="showLabels"
                                                 [assignedLabels]="page.labels"
                                                 [existingLabels]="labels">
                                    </label-table>
                                </td>
                                <td class="text-v-middle text-right notification-right">
                                    <notification-dropdown [showCategories]="showNotifications" [page]="page"></notification-dropdown>
                                </td>
                                <td *ngIf="viewsColumIsAvailable && !(activeTab === 'pdf' || activeTab === 'document')" class="text-v-middle text-right">
                                    <visits [visits]="page.hits" [title]="page.title" [totalVisits]="pages.pageHits">

                                    </visits>
                                </td>
                                <td class="text-v-middle text-right">
                                    <div class="d-flex align-items-center justify-content-end flex-wrap flex-md-nowrap">
                                        <table-page-details
                                                *ngIf="page.type === 'html'"
                                                [ngbTooltip]="'Open page details' | translate"
                                                [triggers]="'focus hover'"
                                                [target]="target"
                                                [subTarget]="subTarget"
                                                [page]="page"
                                                [ref]="ref">
                                        </table-page-details>
                                        <table-document-details
                                                *ngIf="page.type !== 'html'"
                                                [ngbTooltip]="'Open document details' | translate"
                                                [triggers]="'focus hover'"
                                                [target]="target"
                                                [subTarget]="subTarget"
                                                [document]="page">
                                        </table-document-details>
                                        <mon-extension-visual-link-button class="ml-1" [page]="page" [type]="issueType"></mon-extension-visual-link-button>
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </table-container>
                </div>
            </div>
        </div>
    `,
})
export class PrivacyListComponent extends BaseContainerComponentController implements OnInit {
    subheaderTranslation: string = '';
    pages: any = [];
    tabs: any;
    override showFilters: boolean = false;
    showNotifications: any = ['data-privacy'];
    hideNotifications: any = [];
    target: string = 'page-details-section-data-privacy';
    subTarget: string = '';
    override filters: any = { 'Data Regulations': [] };
    override availableFilters: any = {
        'Data Regulations': REGULATIONS,
    };
    override isFiltersOpen: boolean = false;
    exports: any = [];
    viewsColumIsAvailable: boolean = false;
    pageDetailsIsAvailable: boolean = false;
    issueType: string = '';
    ref: string = '';
    progress: any;
    override labels: any;
    override showLabels: boolean = false;
    override selectedLabels: any;
    override selectedLanguages: any;
    promise: any;

    constructor (
        private pageRepoService: PageRepoService,
        private pagesTabsHelper: PagesTabsHelper,
        private activeFeatureService: ActiveFeatureService,
        private translateService: TranslateService,
    ) {
        super({ table: true });
    }

    ngOnInit (): void {
        this.viewsColumIsAvailable = this.activeFeatureService.isFeatureActive('script_setup_guide');
        this.pageDetailsIsAvailable = this.activeFeatureService.isFeatureActive('page_details');
        this.currentSort = { by: 'notification_count', direction: 'desc' };
        this.search = '';
        this.pages = [];
        this.tabs = this.pagesTabsHelper.getTabs();
        this.activeTab = this.pagesTabsHelper.getActiveTab() || 'all';
        this.showFilters = this.activeFeatureService.isFeatureActive('table_filters');
        this.showNotifications = ['data-privacy'];
        this.hideNotifications = this.hideNotifications || [];
        this.target = 'page-details-section-data-privacy';
        this.subheaderTranslation = '';

        this.filters = { 'Data Regulations': [] };
        this.availableFilters = {
            'Data Regulations': REGULATIONS,
        };
        this.isFiltersOpen = false;

        this.exports = [
            {
                name: this.translateService.getString('Issues by Page'),
                data: {
                    category: 'content_with_data_issues',
                },
            },
        ];

        this.getPage();
    }

    getEmptyText (): string {
        return this.translateService.getString('Good job! No issues were found');
    }

    override getPage = (): void => {
        const params: any = {
            page: this.page,
            page_size: this.pageSize,
            sort_by: this.currentSort.by,
            sort_dir: this.currentSort.direction,
            data_protection_violations: true,
            search: this.search || null,
            'regulations[]': this.filters['Data Regulations'].map((regulation: any) => {
                return regulation.value;
            }),
        };

        if (this.selectedLabels && this.selectedLabels.length > 0) {
            params['labels[]'] = this.selectedLabels;
        }

        if (this.selectedLanguages && this.selectedLanguages.length > 0) {
            params['languages[]'] = this.selectedLanguages;
        }

        if (this.activeTab && this.activeTab !== 'all') {
            params['types[]'] = [this.activeTab];
        }

        this.promise = this.pageRepoService.getAll(params).then((data: any) => {
            this.pages = data;
            this.getSubHeaderDescription();
        }, () => {});
    };

    getSubHeaderDescription (): void {
        this.subheaderTranslation = this.translateService.getPlural(
            this.pipeService.get('monNumber')(this.pages.total, '0,0'),
            '1 page',
            '[[$count]] pages',
            {},
            this.pages.total,
        );
    }

    onFiltersChanges (changes: any): void {
        this.filters = changes;
        this.getPage();
    }

    pageTitle (title: string): string {
        return title || '(' + this.translateService.getString('No title found') + ')';
    }
}
